import { QURAN_DATA_VERSION } from '../config/quranDataVersion';

const VERSION_STORAGE_KEY = 'quran-data-version';

const LEGACY_EXACT = ['surahs', 'parahsData'];

function removeLegacyUnversionedKeys() {
  const keys = Object.keys(localStorage);
  for (const k of keys) {
    if (LEGACY_EXACT.includes(k)) {
      localStorage.removeItem(k);
      continue;
    }
    if (k.startsWith('surahData-') || k.startsWith('rukusData-')) {
      localStorage.removeItem(k);
      continue;
    }
    if (k.startsWith('ayahs_')) {
      localStorage.removeItem(k);
      continue;
    }
    if (/^(surah|rukus|words):/.test(k)) {
      localStorage.removeItem(k);
    }
  }
}

function removeAllQdvPrefixedKeys() {
  const keys = Object.keys(localStorage);
  for (const k of keys) {
    if (k.startsWith('qdv')) {
      localStorage.removeItem(k);
    }
  }
}

/**
 * Drop Cache Storage entries owned by public/sw.js (and legacy font SW)
 * so offline JSON cannot outlive QURAN_DATA_VERSION when localStorage migrates.
 */
function clearOfflineCacheStorage() {
  if (typeof caches === 'undefined') return;
  caches
    .keys()
    .then((keys) =>
      Promise.all(
        keys
          .filter(
            (k) =>
              k.startsWith('quran-offline-') || k.startsWith('quran-fonts-')
          )
          .map((k) => caches.delete(k))
      )
    )
    .catch(() => {});
}

/**
 * Call once on app boot. When QURAN_DATA_VERSION changes (e.g. new deploy),
 * drops all versioned Quran mirrors and pre-version keys so data is re-fetched
 * from static JSON instead of stale localStorage / Cache Storage.
 */
export function migrateQuranCacheOnVersionChange() {
  try {
    const stored = localStorage.getItem(VERSION_STORAGE_KEY);
    if (stored === QURAN_DATA_VERSION) return;

    removeAllQdvPrefixedKeys();
    removeLegacyUnversionedKeys();
    localStorage.setItem(VERSION_STORAGE_KEY, QURAN_DATA_VERSION);
    clearOfflineCacheStorage();
  } catch (e) {
    console.warn('Quran cache version migration:', e);
  }
}
